// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBnX8N4SzVaGGfFoBrXJnLD5uW-_JEGzyo",
  authDomain: "quiz24-78f3a.firebaseapp.com",
  projectId: "quiz24-78f3a",
  storageBucket: "quiz24-78f3a.appspot.com",
  messagingSenderId: "985704781060",
  appId: "1:985704781060:web:82f538e9d2a21984c8ec51",
  measurementId: "G-JN9X53CXKB",
  databaseURL:"https://quiz24-78f3a-default-rtdb.europe-west1.firebasedatabase.app"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);